import React, { FC, ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getContext } from '@fiverr-private/fiverr_context';
import { Domingo } from '@fiverr-private/domingo';
import { LazyPortfolioModal, usePortfolioModal, PortfolioModalProps } from '../../PortfolioModal';
import { usePortfolioWidgetContext } from '../PortfolioWidgetContext';

export interface RenderProps extends Pick<ReturnType<typeof usePortfolioModal>, 'openPortfolioModal'> {}

export interface ModalProps extends Pick<PortfolioModalProps, 'projectIds' | 'biEnrichment'> {
  children: (renderProps: RenderProps) => ReactNode;
}

export const Modal: FC<ModalProps> = ({ children, projectIds, biEnrichment }) => {
  const { openPortfolioModal, ...modalProps } = usePortfolioModal();

  const client = useQueryClient();

  const {
    username,
    queryClientDehydratedState,
    servicesConfig: { sellerDataUrlBuilder, portfolioProjectDataUrlBuilder },
  } = usePortfolioWidgetContext();

  return (
    <>
      {children({ openPortfolioModal })}
      <LazyPortfolioModal
        componentProps={{
          biEnrichment,
          servicesConfig: {
            sellerDataUrlBuilder,
            portfolioProjectDataUrlBuilder,
          },
          href: Domingo(getContext().url).path('seller_page', { username }).url,
          username,
          projectIds,
          queryClient: client,
          queryClientDehydratedState,
          ...modalProps,
        }}
      />
    </>
  );
};
